import React, { useCallback } from 'react'
import { getComparisonDates, sizes } from 'helpers/utils'
import { ArrowDownCalendarBranch, CompareIconToday, CompareIconWidth, ScalesComputer, ScalesLeptop, ScalesPhone } from 'media/icons'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import { StyledCompareBtn } from 'style/styled'
import { StyledCompareBtnWrapper, StyledCompareToday, StyledCompareWith } from './styled'
import { Container } from 'components/Dropdown/Dropdown'
import { Checkbox } from 'components/forms'
import { dateFormat } from '../BranchDetails'
import useDeviceType from 'hooks/useDeviceType'

const CompareButton = ({
	activeDate,
	compareDate,
	dateInterval: { dateFrom, dateTo },
	setCompareDate,
	dropdownVisible,
	setDropdownVisible,
	fetchSpecialData
}) => {
	const [t] = useTranslation()
	const { choosenDay, choosenLabel } = compareDate || {}
	const activeWeekDay = moment(activeDate).format(dateFormat)
	const isMobile = useMediaQuery({ query: `(max-width: ${sizes.mobile}px)` })
	const compareList = getComparisonDates(
		dateFrom,
		dateTo,
		activeDate,
		t
	)
	const handleClick = useCallback(({ target }) => {
		const fieldDate = target.getAttribute('field')
		const labelValue = target.getAttribute('title').replace(/ *\([^)]*\) */g, ' ')
		if (fieldDate === activeWeekDay) {
			return
		}
		let specialDate = fieldDate
		if (moment(fieldDate).isAfter(activeDate)) {
			specialDate = moment(fieldDate).subtract(1, 'weeks').format(dateFormat)
		}
		fetchSpecialData(specialDate)
		setDropdownVisible(false)
		setCompareDate({
			choosenDay: specialDate,
			choosenLabel: labelValue
		})
	}, [activeDate, activeWeekDay, fetchSpecialData, setCompareDate, setDropdownVisible])

	const handleCloseClick = useCallback((e) => {
		e.stopPropagation()
		setDropdownVisible(false)
		setCompareDate({ choosenDay: activeWeekDay, choosenLabel: 'Today' })
	}, [activeWeekDay, setCompareDate, setDropdownVisible])

	const triggerDropdown = useCallback(() => {
		setDropdownVisible(prevState => !prevState)
	}, [setDropdownVisible])

	const smallText = choosenLabel === 'Today'

	const userDevice = useDeviceType()
	const notMobileDevice = !(userDevice === 'mobile')

	return (
		<StyledCompareBtnWrapper
			className='compare_btn_wrapper'
		>
			<StyledCompareBtn
				onClick={triggerDropdown}
				className='compare_btn'
				simpleArrow = {!dropdownVisible}
				smallText={smallText}
			>
				<div className='scales_icon'>
					<ScalesComputer className='comp_scales_icon' />
					<ScalesLeptop className='leptop_scales_icon' />
					<ScalesPhone className='phone_scales_icon' />
				</div>
				{
					notMobileDevice &&
				<>
					<span>{t('dashboard_section.compare')}
						{(dropdownVisible || choosenDay !== activeWeekDay) && (
							<StyledCompareToday className='compare compare_today'>{t('dashboard_section.today')} ({
								moment(activeWeekDay, dateFormat).format('DD.MM.YYYY')
							})
							<CompareIconToday />
							</StyledCompareToday>
						)}
						{choosenDay !== activeWeekDay && (
							<StyledCompareWith className='compare compare_width'>
								{choosenLabel} ({moment(choosenDay, dateFormat).format('DD.MM.YYYY')})
								{!isMobile && <CompareIconWidth />}
							</StyledCompareWith>
						)}
					</span>
					<ArrowDownCalendarBranch
						className='down_arrow_branch'
						onClick={handleCloseClick} />
				</>}
			</StyledCompareBtn>
			<Container className='select_container' visible={dropdownVisible} padding={20} backgroundColor='#f6f7fb'>
				{compareList.map(({ field, label }, index) => {
					const isCurrentDay = activeWeekDay === field
					const isChecked = !!(moment(field).isAfter(choosenDay)
						&& moment(field).diff(choosenDay, 'days') === 7)
					const restCheckboxProps = isCurrentDay ? {
						compareTodayStyled: true
					} : choosenDay === field || isChecked ? {
						compareWithStyled: true
					} : {}
					return (
						<Checkbox
							key={`${field}${index}`}
							label={isCurrentDay ? `${label} (${t('dashboard_section.today')})` : label}
							field={field}
							onClick={handleClick}
							onChange={() => { }}
							title={label}
							checked={isCurrentDay || choosenDay === field || isChecked}
							stopPropagation
							noForm
							boxStyles={{ borderRadius: '100%' }}
							{...restCheckboxProps}
						/>
					)
				})}
			</Container>
		</StyledCompareBtnWrapper>
	)
}

export default CompareButton
